import React, {useRef} from "react";
import { Form } from 'antd';
import { addPublisher } from "../../stateManagement/actions/data";
import { useDispatch } from "react-redux";
import BasicFormButtons from "./basicFormButtons";
import InputFormField from "./inputFormField";

const NewPublisherForm = ({reloadData}) => {

    // Form reference for resetting
    const formRef = useRef(null);

    const dispatch = useDispatch();

    //Reset form fields
    const handleReset = () => formRef.current?.resetFields();

    // Handle form submission
    const onFinish = (values) => {
        // Dispatch action to add website
        dispatch(addPublisher(values));
        // Reset form and reload data
        handleReset();
        reloadData();
    };

    return(
        <Form ref={formRef} onFinish={onFinish}>
            <InputFormField label="Report name:" name="currentValue"/>
            <InputFormField label="Platform name:" name="returnedValue"/>
            <BasicFormButtons handleReset={handleReset}/>
        </Form>
    )
}

export default NewPublisherForm;